const API_URL =
  process.env.REACT_APP_API_URL ||
  process.env.VITE_API_URL ||
  "https://ecovanta.onrender.com";

function getToken() {
  return localStorage.getItem("token");
}

function authHeaders() {
  const token = getToken();

  return token
    ? {
        Authorization: `Bearer ${token}`,
      }
    : {};
}

export async function uploadDocument(file, documentType = "auto") {
  const formData = new FormData();
  formData.append("document", file);
  formData.append("documentType", documentType || "auto");

  const response = await fetch(`${API_URL}/documents/upload`, {
    method: "POST",
    headers: {
      ...authHeaders(),
    },
    body: formData,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to upload document");
  }

  return data;
}

export async function processDocument(documentId) {
  const response = await fetch(`${API_URL}/documents/${documentId}/process`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...authHeaders(),
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to process document");
  }

  return data;
}

export async function getDocuments() {
  const response = await fetch(`${API_URL}/documents`, {
    headers: {
      ...authHeaders(),
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to fetch documents");
  }

  return data;
}

export async function getDocumentById(documentId) {
  const response = await fetch(`${API_URL}/documents/${documentId}`, {
    headers: {
      ...authHeaders(),
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to fetch document");
  }

  return data;
}

export async function getReports() {
  const response = await fetch(`${API_URL}/reports`, {
    headers: {
      ...authHeaders(),
    },
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to fetch reports");
  }

  return data;
}

export async function attachEvidenceToReport(documentId, evidenceIndex, reportId) {
  const response = await fetch(
    `${API_URL}/documents/${documentId}/evidence/${evidenceIndex}/attach`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        ...authHeaders(),
      },
      body: JSON.stringify({ reportId }),
    }
  );

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || "Failed to attach evidence to report");
  }

  return data;
}